// extracted by mini-css-extract-plugin
export default {"container":"styles_container__sgIB3","content":"styles_content__Iw0Sa","editing":"styles_editing__xMJIo"};